export default "__VITE_ASSET__b260f9c1__"